import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldSelectMultipleComponent } from './field-select-multiple.component';
import { FormsModule } from '@angular/forms';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { CardDataSetModule } from '../../card-data-set';
import { DurationTextModule } from '../../duration-text';
import { MatChipsModule } from '@angular/material/chips';



@NgModule({
  declarations: [
    FieldSelectMultipleComponent
  ],
  exports: [
    FieldSelectMultipleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CardComponent,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    DurationTextModule,
    MatChipsModule
  ]
})
export class FieldSelectMultipleModule { }
